import numerator from '../../plugins/jquery-numerator.js';


//=========== カンマ削除 ============//
function removeComma(number) {
  var removed = number.replace(/,/g, '');
  return parseInt(removed, 10);
}


  if (window.matchMedia( "(max-width: 820px)" ).matches) {
    var viewFactor_num_01 = '0.2';
  } else {
    var viewFactor_num_01 = '1';
  }


ScrollReveal().reveal('.animate_grah_count_01', {
  duration: 1200,
  distance: '30px',
  origin: 'bottom',
  viewFactor: viewFactor_num_01,
  afterReveal: function (el) {
    let count_up_01 = $("#count-up-01 .count-up-max").text();
    count_up_01 = removeComma(count_up_01); 
    $('#count-up-01 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_01, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
  }
});


ScrollReveal().reveal('.animate_grah_count_02', {
  duration: 1200,
  distance: '30px',
  origin: 'bottom',
  viewFactor: viewFactor_num_01,
  afterReveal: function (el) {
    let count_up_02 = $("#count-up-02 .count-up-max").text();
    count_up_02 = removeComma(count_up_02); 
    $('#count-up-02 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_02, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
  }
});



ScrollReveal().reveal('.animate_grah_count_03', {
  duration: 1200,
  distance: '30px',
  origin: 'bottom',
  viewFactor: viewFactor_num_01,
  afterReveal: function (el) {
    let count_up_03 = $("#count-up-03 .count-up-max").text();
    //count_up_03 = removeComma(count_up_03); 
    $('#count-up-03 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_03, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 1 // 小数点以下の桁数
    });
  }
});



ScrollReveal().reveal('.animate_grah_count_04', {
  duration: 1200,
  distance: '30px',
  origin: 'bottom',
  viewFactor: viewFactor_num_01,
  afterReveal: function (el) {
    let count_up_04 = $("#count-up-04 .count-up-max").text();
    count_up_04 = removeComma(count_up_04); 
    $('#count-up-04 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_04, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
  }
});


ScrollReveal().reveal('.animate_grah_count_05', {
  duration: 1200,
  distance: '30px',
  origin: 'bottom',
  viewFactor: viewFactor_num_01,
  afterReveal: function (el) {
    let count_up_05 = $("#count-up-05 .count-up-max").text();
    //count_up_05 = removeComma(count_up_05); 
    $('#count-up-05 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_05, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 1 // 小数点以下の桁数
    });
  }
});


ScrollReveal().reveal('.animate_grah_count_06', {
  duration: 1200,
  distance: '30px',
  origin: 'bottom',
  viewFactor: viewFactor_num_01,
  afterReveal: function (el) {
    let count_up_06 = $("#count-up-06 .count-up-max").text();
    count_up_06 = removeComma(count_up_06); 
    $('#count-up-06 .count-up').numerator( {
      easing: 'linear', // アニメーションの動き
      duration: 1000, // アニメーションの時間
      toValue: count_up_06, // どこまでカウントアップするか
      delimiter: ',', // ３桁ごとに区切る値
      rounding: 0 // 小数点以下の桁数
    });
  }
});